import React, { useCallback } from "react";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";
import { useCurrentWorkspace } from "@/store";
import { projectSelector } from "@rflocal/shared";

interface OutOfCreditsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const OutOfCreditsModal: React.FC<OutOfCreditsModalProps> = ({ isOpen, onClose }) => {
    const workspace = useCurrentWorkspace();

    const handleUpgrade = useCallback(() => {
        // Navigate to billing page
        if (workspace?.url) {
            window.open(
                `${projectSelector.appUrl(false, true)}/${workspace.url}/upgrade?fsrc=rapid-out-of-credits`,
                "_blank"
            );
        }
        onClose();
    }, [workspace?.url, onClose]);

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={handleUpgrade}
            type="warning"
            size="md"
            icon="far fa-credit-card"
            title="Out of Credits"
            submitButtonText="Upgrade Plan"
            cancelButtonText="Close"
            submitButtonProps={{ type: "primary" }}
        >
            <div className="flex flex-col gap-3 text-center">
                <p>You've used all your available credits for this workspace.</p>
                <p>
                    To continue testing your model, please upgrade your plan or wait for your
                    credits to renew.
                </p>
            </div>
        </ModalWithIcon>
    );
};
